module.exports = __webpack_public_path__ + "assets/img/99d4ad2f48263f18ede2dad131a3d975.png";